import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Grid, Row, Col} from 'react-bootstrap'
import OrderLimitEditForm from './order-limit-edit-form';
import BackLink from '../../../common/back-link/index'
import PageTitle from "../../../common/page-title/index";
import {getOrderLimit, downloadOutletOrderLimits} from '../../../../actions/order-limits';
import {getCategories} from '../../../../actions/categories';
import ArrowButton from "../../../common/button-arrow";
import {actions} from "react-redux-form";
import {initialStates} from "../../../../initialStates";

class EditOrderLimit extends Component {

  constructor(props){
    super(props);
  }

  componentDidMount() {
    const id = +this.props.match.params.id;
    const {dispatch} = this.props;
    if (id) {
      dispatch(getOrderLimit(id));
      dispatch(getCategories('', 'INITIALIZE_EDIT_ORDER_LIMIT'));
    }
  }

  componentWillUnmount(){
    this.props.dispatch(actions.load('deep.admin_order_limit', initialStates.admin_order_limit));
    this.props.dispatch({type: 'CLEAR_EDIT_ORDER_LIMIT'});
  }

  onDownloadOutletOrderLimitsClick = () => {
    const {dispatch, orderLimit} = this.props;
    const type = orderLimit.attributes['transaction-type'] === 'monthly maximum' ? "monthly" : "adhoc";
    dispatch(downloadOutletOrderLimits(type));
  };

  render(){
    return(
      <Grid bsClass="container" fluid className="order-limits">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/order_limits"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>Edit Order Limit</PageTitle>
            <Col md={12}>
              <Row>
                <ArrowButton
                  className="float-right"
                  arrow={false}
                  submit={false}
                  onClick={this.onDownloadOutletOrderLimitsClick}>Download outlet order limits</ArrowButton>
              </Row>
            </Col>
            <OrderLimitEditForm orderLimit={this.props.orderLimit}/>
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orderLimit: state.orderLimits.orderLimit,
    fetched: state.orderLimits.fetched,
    fetching: state.orderLimits.fetching,
  };
};

export default connect(mapStateToProps)(EditOrderLimit);



// WEBPACK FOOTER //
// ./src/components/admin/order-limits/edit/index.jsx